console.log("Search Engine Loaded");

function searchProducts(message){

    message = message.toLowerCase();

    //----------------------------------------
    // Detect Family
    //----------------------------------------

    let family = null;

    if(
        message.includes("camera") ||
        message.includes("cctv") ||
        message.includes("cc camera") ||
        message.includes("security camera")
    ){

        family = "CCTV";

    }

    else if(
        message.includes("spy") ||
        message.includes("hidden")
    ){

        family = "HIDDEN_CAMERA";

    }

    else if(
        message.includes("fingerprint") ||
        message.includes("lock")
    ){

        family = "FINGERPRINT_LOCK";

    }

    else if(
        message.includes("gps")
    ){

        family = "GPS";

    }

    else if(
        message.includes("doorbell")
    ){

        family = "VIDEO_DOORBELL";

    }

    //----------------------------------------

    let products = ALL_PRODUCTS;

    if(family){

        products = ALL_PRODUCTS.filter(product=>{

            return detectProductFamily(product) === family;

        });

    }

    console.log("Family :", family);

    console.log("Products :", products.length);

    return products;

}